(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-faqs"] && !window.DesignMode) return;
  try {
    
var acc = document.getElementsByClassName("jd-accordion-button");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    if (jQuery(this).hasClass('active')) {
      jQuery(".jd-accordion-button").removeClass("active");
      jQuery(".jd-accordion-panel").removeClass("panel-active").slideUp('fast');
    } else {
      jQuery(".jd-accordion-button").removeClass("active");
      jQuery(".jd-accordion-panel").removeClass("panel-active").slideUp('fast');
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      jQuery(panel).toggleClass("panel-active").slideToggle('fast');
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
